
		var translate_subtotal			= "Subtotal";
		var translate_subtotalexclvat	= "Total excl. VAT";
		var translate_vat				= "VAT";
		var translate_total				= "Total";
		var translate_discount_applied	= "Your coupon code has been applied";
		var translate_discount_invalid	= "The provided code is invalid";

		var user_type					= "";
	


